import { type InsuranceCheckFormDataCMS } from "@repo/common/src/types/firestore/cms/insuranceCheckFormData";
import { CMSCollections } from "@repo/common/src/types/firestore/collections";
import { buildCollection, buildEntityCallbacks, buildProperty, type EntityOnSaveProps } from "@firecms/core";

import { Groups } from "./types";
import { standardPermissions } from "../utils/constants";
import { loadingOverlay } from "../utils/loadOverlay";

const callbacks = buildEntityCallbacks({
  onPreSave: async (props: EntityOnSaveProps<InsuranceCheckFormDataCMS>) => {
    loadingOverlay.show();
    const { values } = props;
    return values;
  },
  onSaveSuccess: async () => {
    loadingOverlay.hide();
  },
  onSaveFailure: async () => {
    loadingOverlay.hide();
  },
});

export const insuranceCheckFormData = buildCollection<InsuranceCheckFormDataCMS>({
  id: CMSCollections.InsuranceCheckFormData,
  name: "KrankenkassenFormular Daten",
  description: "Mehrere Einträge können hinter einem Dokument hinterlegt werden.",
  singularName: "KrankenkassenFormular Daten",
  path: CMSCollections.InsuranceCheckFormData,
  icon: "LocalPharmacy",
  group: Groups.Other,
  subcollections: [],
  permissions: () => {
    return standardPermissions;
  },
  callbacks,
  properties: {
    insurances: buildProperty({
      dataType: "array",
      name: "Krankenkassen",
      of: buildProperty({
        dataType: "map",
        name: "Krankenkasse",
        properties: {
          name: buildProperty({
            dataType: "string",
            name: "Name der Krankenkasse",
            validation: {
              required: true,
            },
          }),
          financialSupport: buildProperty({
            dataType: "string",
            name: "Finanzielle Unterstützung",
            validation: {
              required: true,
            },
          }),
        },
      }),
      description: "List of insurance providers",
      validation: {
        required: true,
      },
    }),
    updated_on: buildProperty({
      name: "Aktualisierungsdatum",
      dataType: "date",
      autoValue: "on_update",
    }),
  },
});
